import styled, { ThemeGradient } from 'styled-components'

export const WithGradient = styled.span<{ $gradient: ThemeGradient }>`
  background: ${({ theme, $gradient }) => theme.gradients[$gradient]};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`
